import { render, staticRenderFns } from "./MilkSchedule.vue?vue&type=template&id=5692551f&"
import script from "./MilkSchedule.vue?vue&type=script&lang=js&"
export * from "./MilkSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MilkSchedule.vue"
export default component.exports